import Job from 'models/Job';
import JobCity from 'models/JobCity';

import Component from './component';

export interface Props {
   job: Job;
   jobCity: JobCity;
   icons: {
      bullet: string;
      bulletAlt?: string;
      offer: string;
      offerAlt?: string;
      location: string;
      locationAlt?:string;
      cv: string;
      cvAlt?:string;
      mode: string;
      modeAlt?:string;
      exp: string;
      expAlt?:string
   };
   titles: {
      cvRequired: string;
      cvFree: string;
   }
}

Component.defaultProps = {};

export default Component;